<app-header [selectedMenu]="MENU_PAGE.REFERENCE"></app-header>

<div class="container">

  <div class="wrapper">
    <aside class="rope"></aside>
    <app-back-btn></app-back-btn>

  </div>


  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>

</div>

